import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogGrade } from "../../../models/CatalogGrade";
import { useCatalogGradeContext } from "../context/CatalogGradeContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setGrade: (grade: CatalogGrade) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setGrade,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogGradeContext();

  const rows: CatalogGrade[] =
    state.grades?.map((grade: CatalogGrade) => ({
      ...grade,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "GradeName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setGrade,
        data: params.data as CatalogGrade,
        setShowModal: setShowModal,
        del: false,
        showContextMenu: () =>
          showContextMenu(event, params.data, "gradeContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
